import { usePageTitle } from '@/hooks/use-document-title'
import Footer from './footer'

interface PolicySection {
  title: string
  body: string
}

const sections: PolicySection[] = [
  {
    title: 'Our Commitment',
    body: 'We take the security of your data seriously and welcome reports from security researchers who help us keep Beyond CTCI safe. Researchers who act in good faith and follow this policy will not face legal action from us.',
  },
  {
    title: 'Scope',
    body: 'This policy covers the Beyond CTCI web application and the services we operate. Issues in third-party services we rely on (such as authentication or payment providers) should be reported to those vendors directly.',
  },
  {
    title: 'Rules of Engagement',
    body: 'Do no harm: test only against your own accounts, never access or modify other users’ data, and avoid anything that degrades the service for others. Automated scanning that generates significant load is not permitted.',
  },
  {
    title: 'How to Report',
    body: 'If you believe you have found a vulnerability, contact us with a description of the issue, steps to reproduce it, and its potential impact. We appreciate detailed reports and will keep you updated as we investigate.',
  },
  {
    title: 'Coordinated Disclosure',
    body: 'Please give us a reasonable window to investigate and remediate an issue before disclosing it publicly. We will work with you on timing and credit you for the discovery if you would like.',
  },
]

export default function SecurityPolicy() {
  usePageTitle('Security')

  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col">
      <div className="container mx-auto max-w-4xl px-4 py-12">
        <h1 className="mb-4 text-4xl font-bold tracking-tight">Security</h1>
        <p className="text-muted-foreground mb-12 max-w-3xl text-lg leading-relaxed">
          How we protect the platform, and how to responsibly report a
          vulnerability if you find one.
        </p>

        {sections.map(({ title, body }) => (
          <section key={title} className="mb-10">
            <h2 className="mb-3 text-2xl font-semibold">{title}</h2>
            <p className="text-muted-foreground leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
      <Footer />
    </div>
  )
}
